import { useI18n } from 'vue-i18n';

const overlayMessages = {
  en: {
    alertMessage: 'Hold your iPhone to the key tag',
    successMessage: 'Key tag programmed',
  },
  de: {
    alertMessage: 'Halte dein iPhone an den Schlüsselanhänger',
    successMessage: 'Schlüsselanhänger programmiert',
  },
  es: {
    alertMessage: 'Acerca el iPhone al llavero',
    successMessage: 'Llavero programado',
  },
} as const;

type OverlayLocale = keyof typeof overlayMessages;

/** NFC sheet copy shared by car stickers and rental key tags. */
export const useNfcSunOverlay = () => {
  // Global composer ignores a local `messages` map — look up by locale instead.
  const { locale } = useI18n({ useScope: 'global' });
  const resolve = () => overlayMessages[locale.value as OverlayLocale] ?? overlayMessages.en;
  return {
    alertMessage: () => resolve().alertMessage,
    successMessage: () => resolve().successMessage,
  };
};
